import { alpha, hexToRgb, styled } from "@mui/material/styles";
import { StyleguideSavioFonts } from "../../../../configuration/themeSettings";
import { SxProps, Typography, useTheme } from "@mui/material";

export const InstalledBaseImg = styled("div", { label: "InstalledBasePage-Img" })
    (({ theme }) => ({
        width: "100%",
        height: 105,
       // minHeight: 150,
        backgroundColor: "#ccc",
        margin: "10px 0",
        marginTop: 0,
    }))


export const SiteSelected = styled("div", { label: "InstalledBasePage-Site" })
    (({ theme }) => ({
        width: "100%",
        background: theme.palette.primary.main,// `${alpha(theme.palette.primary.main, .5)}`,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        color: theme.palette.common.white,
        justifyContent: "center",
        fontSize: 20,
        fontWeight: StyleguideSavioFonts.light,
    }))

export const CustomeSiteText = styled(Typography, { label: "home-customer_site_text" })
    (({ theme }) => ({
        fontWeight: StyleguideSavioFonts.light,
        fontSize: 16,
        marginBottom: 16,
       
    }))

export const AddressSiteText = styled("span", { label: "home-address_site_text" })
    (({ theme }) => ({
        fontWeight: StyleguideSavioFonts.medium,
        fontSize: 14,
        lineHeight: 'normal',
        display: 'block',
        marginTop: 6,
    }))

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        text: {
            fontSize: 25,
            fontWeight: StyleguideSavioFonts.medium,
            lineHeight: '24px',
        } as SxProps,
    };
    return classes;
};
